module.exports = __webpack_public_path__ + "img/mdi_steam.f1610feb.svg";